import React, { useState } from 'react';
import { Plus } from 'lucide-react';
const faqs = [{
  q: '¿Es un pago único o hay cargos mensuales?',
  a: 'Es un pago único de $9.99 USD y el acceso es para siempre. Sin suscripciones, sin sorpresas, sin cargos ocultos. Una inversión y el material es tuyo de por vida.'
}, {
  q: '¿Necesito experiencia previa en manifestación o meditación?',
  a: 'Absolutamente no. El sistema está diseñado para llevarte de la mano desde cero. De hecho, si nunca has intentado manifestar, tienes ventaja: sin hábitos erróneos que corregir.'
}, {
  q: '¿Cómo y cuándo recibo el material?',
  a: 'Inmediatamente después del pago recibirás un correo con los accesos a todos los materiales: el ebook principal y los 3 bonos. Si en 5 minutos no ves el correo, revisa spam o escríbenos.'
}, {
  q: '¿En qué formato están los materiales?',
  a: 'El ebook y el diario son PDFs descargables, compatibles con cualquier dispositivo. Los Sonidos Mágicos son archivos de audio (MP3) que puedes escuchar en tu teléfono, computadora o tablet.'
}, {
  q: '¿Funciona aunque sea muy escéptico(a)?',
  a: 'El escepticismo es una señal de inteligencia, no un obstáculo. El sistema combina principios de neurociencia con prácticas de reprogramación. No necesitas creer ciegamente; solo aplicar. Los resultados hablan solos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-primary" data-id="element-77" data-mp="11v5u4csaxz4f">
      <div className="max-w-[1100px] mx-auto px-5" data-id="element-78" data-mp="16o7akp85q6q4">
        <div className="text-center mb-12" data-id="element-79" data-mp="16q1ymceq6eyf">
          <span className="inline-block text-xs font-semibold tracking-[0.15em] uppercase text-violet-light mb-4" data-id="element-80" data-mp="rzudfoxc2hu1">
            Respuestas Rápidas
          </span>
          <h2 className="font-display text-3xl md:text-[42px] font-bold leading-[1.2] text-white" data-id="element-81" data-mp="wvt4xldykfyo">
            Tus dudas, <span className="text-gold" data-id="element-82" data-mp="mzyh8buvnup1">resueltas.</span>
          </h2>
        </div>

        <div className="max-w-[720px] mx-auto flex flex-col gap-3" data-id="element-83" data-mp="n1ssszk9eagg">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-card border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-gold/35' : 'border-gold/15'}`} data-id="element-84" data-mp="2kuc6gy5hei9p" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-6 py-5 flex justify-between items-center text-left font-semibold text-[15px] text-white hover:text-gold transition-colors gap-4" data-id="element-85" data-mp="2azk3fet4r37j">
                  {faq.q}
                  <div className={`shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-gold/20 text-gold rotate-45' : 'bg-gold/10 text-gold'}`} data-id="element-86" data-mp="2ypej044u35vh">
                    <Plus className="w-4 h-4" data-id="element-87" data-mp="1n61ym2j0l0ao" />
                  </div>
                </button>
                <div className={`px-6 text-sm text-gray-400 leading-relaxed overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[200px] pb-5 opacity-100' : 'max-h-0 pb-0 opacity-0'}`} data-id="element-88" data-mp="1j59shi5fvbim">
                  {faq.a}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}